import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';

import {SET_SECTION_DETAILS} from '../../actions/types';

import right from '../../svg/chevron_right.svg';

class HelpSupportCard extends Component {

    /**
     * it sends the title and description of the category clicked to the store
     */

    saveHelpTitleDesc() {
        let dataToSend = {
            title : this.props.displayData.name,
            description : this.props.displayData.description
        }
        this.props.setHeadetDetails(dataToSend);
    }

    render() {

        return (
            <Link className="help-support-card-container" to={"/helplist/" + this.props.displayData.id} onClick={this.saveHelpTitleDesc.bind(this)}>
                <div className="help-support-card">
                    <div className="help-support-card-title">
                        {this.props.displayData.name}
                    </div>
                    <div className="help-support-card-desc">
                        {this.props.displayData.description}
                    </div>
                </div>
                <div className="help-support-card-icon">
                    <img src={right} alt="" />
                </div>
            </Link>
        )
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        setHeadetDetails : (headerData) =>{
            dispatch({
                type: SET_SECTION_DETAILS,
                payload: headerData
            })
        }
    }
}

export default connect(null, mapDispatchToProps) (HelpSupportCard);


// WEBPACK FOOTER //
// ./src/components/Landing/HelpCard.js